/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import Zipcode from './Zipcode';
// 이미지
import closeImage from "../../img/sub/btn_close2.png";

/* const { kakao } = window; */
const DaumPostCode = ({varOpenZipcode,ChangeAddress,ClosePopupZipcode}) => {

  //주소가 선택되면
  const onCompleteZipcodeHandler = (data) => {
    let fullAddr = data.jibunAddress===""?data.autoJibunAddress:data.jibunAddress; //address;
    let extraAddr = "";
    //const regcode = data.bcode;   //행정구역 동코드 
    //const dongName = data.bname;  //동이름
    const roadAddress = data.roadAddress;  //도로주소
    const zipcode = data.zonecode;  //우편번호
    //const buildingName : data.buildingName;  //건물/아파트/단지명 -- 둥지매물등록시
    console.log(data);

    //특수주소 재정리
    if (data.addressType === "R") {
      if (data.buildingName !== "") {
        extraAddr += extraAddr !== "" ? `, ${data.buildingName}` : data.buildingName;
        fullAddr += extraAddr !== "" ? ` (${extraAddr})` : "";
      }
    }
    //좌표만들기
    //getLocation(zipcode,fullAddr,roadAddress);
    ChangeAddress(zipcode,fullAddr,roadAddress,"");
    //우편번호 창닫기
    ClosePopupZipcode();
  };
  
  // 주소로 좌표를 검색합니다
/*   const getLocation = (zipcode,fullAddr,roadAddress) => {
    var geocoder = new kakao.maps.services.Geocoder();
    geocoder.addressSearch(fullAddr, function (result, status) {
      if (status === kakao.maps.services.Status.OK) {
        const latpos = result[0].y;
        const longpos = result[0].x;
        const locString = `${latpos},${longpos}`;
        ChangeAddress(zipcode,fullAddr,roadAddress,locString);
      } else {
        ChangeAddress(zipcode,fullAddr,roadAddress,"");
      }
    });
  }  */

  return (
    <div className="poplayerZipcodeSearch" style={varOpenZipcode?{display:"block"}:{display:"none"}}>
      <div className="consbox" style={{ zIndex: 999 }}>
        <div className="btnclose" onClick={()=>ClosePopupZipcode(false)}><img src={closeImage} className="popup-image" alt="" /></div>
        {varOpenZipcode?
        <Zipcode varOpenZipcode={varOpenZipcode} ClosePopupZipcode={ClosePopupZipcode} onCompleteZipcodeHandler={onCompleteZipcodeHandler}/>
        :null}
      </div>
    </div>
  );
}

export default DaumPostCode;